/**
 * The retired Studio (`/studio/*`) lands in Firm Knowledge. An edit link to a
 * legacy template carries its id along so the library opens that entry.
 */
import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { studioRedirectTarget } from "./routes";

export const StudioRedirect: FC = () => {
  const { pathname } = useLocation();
  return <Navigate to={studioRedirectTarget(pathname)} replace />;
};
